import React, { Fragment } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Divider, Grid, InputAdornment, TextField } from "@mui/material";

import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";

const SearchBar = ({ selected, placeholder }) => {
  return (
    <Grid container alignItems={"center"}>
      <TextField
        variant="outlined"
        placeholder={placeholder ? placeholder : "Search name, phone, email"}
        // value={""}
        // handleChange={}
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />
      {selected && selected.length > 0 && (
        <Fragment>
          <span style={selectedItemsStyles}>{selected.length} selected</span>
          <TrendingFlatIcon fontSize="large" style={{ color: "#919191" }} />
          <span style={statusTextSTyles}>Approved</span>
          <Divider orientation="vertical" style={{ height: 25 }} />
          <span style={statusTextSTyles}>Pending</span>
          <Divider orientation="vertical" style={{ height: 25 }} />
          <span style={statusTextSTyles}>Denied</span>
          <Divider orientation="vertical" style={{ height: 25 }} />
          <span style={statusTextSTyles}>Removed</span>
        </Fragment>
      )}
    </Grid>
  );
};

export default SearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 270,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif"
};

const selectedItemsStyles = {
  color: "#020303",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif"
};

const statusTextSTyles = {
  color: "#00A7CD",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif"
};
